import { AlertTriangle } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface TaskConflictDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onViewExisting: () => void;
  onCreateAnyway: () => void;
  existingTaskName: string;
  typeName: string;
  isCreating?: boolean;
}

export const TaskConflictDialog = ({
  isOpen,
  onClose,
  onViewExisting,
  onCreateAnyway,
  existingTaskName,
  typeName,
  isCreating = false,
}: TaskConflictDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent className="z-[60] max-w-md" overlayClassName="z-[60]">
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-600" />
            <AlertDialogTitle>Task Already Exists</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-gray-600 dark:text-zinc-400">
            A{' '}
            <span className="font-medium text-gray-900 dark:text-white">
              {typeName}
            </span>{' '}
            task already exists for this matter:
            <span className="mt-2 block rounded border border-gray-200 bg-gray-50 p-2 text-sm font-medium text-gray-900 dark:border-zinc-700 dark:bg-zinc-800 dark:text-white">
              {existingTaskName}
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row">
          <AlertDialogCancel asChild>
            <Button variant="outline" onClick={onClose} disabled={isCreating}>
              Cancel
            </Button>
          </AlertDialogCancel>
          <Button
            variant="outline"
            onClick={onViewExisting}
            disabled={isCreating}
          >
            View Existing Task
          </Button>
          <AlertDialogAction asChild>
            <Button onClick={onCreateAnyway} disabled={isCreating}>
              {isCreating ? 'Creating...' : 'Create Anyway'}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
